import type {ConversationId} from '../domain/conversation-id.value-object';

export const keys = {
  listAll: () => ['assistant', 'conversations'] as const,
  detail: (id: ConversationId) => ['assistant', 'conversations', id] as const,
  mutations: {
    create: () => ['assistant', 'mutations', 'create'] as const,
    delete: () => ['assistant', 'mutations', 'delete'] as const,
    applyProposal: () => ['assistant', 'mutations', 'apply-proposal'] as const,
    discardProposal: () => ['assistant', 'mutations', 'discard-proposal'] as const,
    uploadAttachment: () => ['assistant', 'mutations', 'upload-attachment'] as const,
    deleteAttachment: () => ['assistant', 'mutations', 'delete-attachment'] as const,
  },
} as const;
